import React, { KeyboardEvent, MouseEvent, ReactNode, useCallback } from 'react'

enum KeyboardKey {
  Enter = 'Enter',
  Space = ' ',
}

interface ButtonDivProps {
  children: ReactNode
  onClick: (
    e: MouseEvent<HTMLDivElement> | KeyboardEvent<HTMLDivElement>
  ) => void
  className?: string
  id?: string
  title?: string
  ariaLabel?: string
}

function ButtonDiv({
  children,
  onClick,
  className = '',
  id,
  title,
  ariaLabel,
}: ButtonDivProps) {
  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === KeyboardKey.Enter || e.key === KeyboardKey.Space) {
        e.preventDefault()
        onClick(e)
      }
    },
    [onClick]
  )

  return (
    <div
      id={id}
      title={title}
      aria-label={ariaLabel}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={`cursor-pointer focus:outline-none focus:ring-2 ${className}`}
    >
      {children}
    </div>
  )
}

export default ButtonDiv
